import React from "react";
import { Button } from "antd";
import { BASE_URL } from "../../../../constants/enviroment";
import { Session, Utilitaries } from "../../../../business";

export function QaLink({ itemData, record }) {
    const value = record ? Utilitaries.toString(record[itemData.key]) : itemData.value;

    async function onItemClick() {
        try {
            let url = "";
            if (value && value?.startsWith("/PHP/Gestor")) {
                url = `${BASE_URL}${value}&token=Bearer ${Session.getToken()}`;
            } else {
                url = value;
            }

            // UNICV  Verificação do curriculum vitae de docente url no valores da tabela
            if (value) {
                window.open(url, "_blank");

                return;
            }
        } catch (error) {}
    }

    if (!value) {
        return null;
    }

    return <Button onClick={() => onItemClick()} icon="link" />;
}
